import validateTime from "./validateTime";

const validateEndTime = (endTime, startTime) => {
  if (endTime <= startTime) {
    return "End time must be after start time.";
  } else {
    return validateTime(endTime);
  }
};

export default validateEndTime;
